import { render, staticRenderFns } from "./ModelType.vue?vue&type=template&id=ad4e029a&scoped=true"
import script from "./ModelType.vue?vue&type=script&lang=js"
export * from "./ModelType.vue?vue&type=script&lang=js"
import style0 from "./ModelType.vue?vue&type=style&index=0&id=ad4e029a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4e029a",
  null
  
)

export default component.exports